import { StorageService } from './storage.service';
import { Injectable } from '@angular/core';

@Injectable()
export class SessionStorageService implements StorageService{

  constructor() { }

  write(key: string, value: any) : void {
      if (value) {
          value = JSON.stringify(value);
      }
      sessionStorage.setItem(key, value);
  }

  read<TData>(key: string): TData {
      let value: string = sessionStorage.getItem(key);
      if (value && value != "undefined" && value != "null") {
          return <TData>JSON.parse(value);
      }
      return null;
  }

  /** Removes an item which corriponds to the given key. */
  remove(key: string) : void {
    sessionStorage.removeItem(key);
  }

  /** Verifyes if there's an item with the given key. */
  contains(key: string) : boolean {
    var item = sessionStorage.getItem(key);
    return item != undefined && item != null;
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/services/cache/session-storage.service.ts